const navbar = {
  packages: "Gói hàng", // translated 
  hotelPackages: "Gói khách sạn", // translated 
  experiences: "Trải nghiệm", // translated 
  close: "Đóng", // translated 
  hotDeals: "Ưu đãi hấp dẫn", // translated 
  dashboard: "Bảng điều khiển", // translated 
  pricing: "Giá cả", // translated 
};


export default navbar;
